module.exports = __webpack_public_path__ + "static/media/poll.b347c202.svg";